import React from 'react';

/**
 * PaymentAmountDisplay Component
 * Reusable amount display component with currency formatting
 */
const PaymentAmountDisplay = ({ 
  amount, 
  currency = 'INR', 
  size = 'default',
  showIcon = true,
  className = '' 
}) => {
  const formatAmount = (amt) => {
    if (typeof amt === 'string') {
      // Remove currency symbols and parse
      const num = parseFloat(amt.replace(/[₹,\s]/g, ''));
      return isNaN(num) ? 0 : num;
    }
    if (typeof amt === 'object' && amt?.toString) {
      return parseFloat(amt.toString());
    }
    return parseFloat(amt) || 0;
  };

  const formattedAmount = formatAmount(amount);
  const currencySymbol = currency === 'INR' ? '₹' : currency;

  const sizeClasses = {
    small: 'text-lg',
    default: 'text-2xl',
    large: 'text-4xl'
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* DollarSign icon removed for consistent UI */}
      <span className={`font-bold text-green-900 ${sizeClasses[size]}`}>
        {currencySymbol}{formattedAmount.toFixed(2)}
      </span>
    </div>
  );
};

export default PaymentAmountDisplay;

